<template>
	<div class="product-list">
		<div class="productlistback" :style="{background: back,}">
			<div class="product-list-header" @click="productListClick(type)">
				<div class="protitlebox">
					<span class="heti">{{ title1 }}</span>
					<span>{{ title2 }}</span>
					<p class="morelist"><span class="iconfont">View all &#xe650;</span></p>
				</div>
				
				<!--<div class="header-icon"></div>
				<span class="header-title">{{ title1 }}</span>
				<span class="iconfont">&#xe650;</span>-->
			</div>
		</div>
		<div class="product-list-body">
			<index-product-body
				:item="item"
				:index="index"
				v-for="(item, index) in items"
				v-bind:key="index"
			></index-product-body>
		</div>
	</div>
</template>

<script>
import IndexProductBody from './IndexProductBody'

export default {
  name: 'IndexProductList',
  data () {
    return {}
  },
  props: ['items', 'title1', 'title2', 'type','back'],
  components: {
    IndexProductBody
  },
  computed: {

  },
  methods: {
    productListClick: function (type) {
      this.$router.push({
        name: 'HomeGoodslist',
        query: { sort_key: type }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.product-list {
	margin-top:0.6rem;
	margin-bottom:0.6rem;
	.product-list-header {
		display: flex;
		height:2rem;
		padding: 0 0.25rem;
		justify-content: space-between;
		align-items: center;
		.header-title {
			font-size:0.8rem;
			color: #333;
			font-weight:700;
		}
		.header-icon {
			width:1rem;
			height:1rem;
		}
	}
	.product-list-body {
		display: flex;
		flex-wrap: wrap;
	}
}
body .product-list .productlistback{height: 8rem;border-top-left-radius: 0.8rem;border-top-right-radius: 0.8rem;padding: 0.9rem 0;}
.protitlebox{text-align: center;width: 100%;position: relative;}
.protitlebox span{display: inline-block;font-size: 1.5rem;color: #FFF;font-weight: bold;letter-spacing: 1px;}
.protitlebox span.heti{font-size: 1rem;border-bottom: 0.3rem solid #ffff00;color: #FFF;vertical-align: text-bottom;margin-right: 0.15rem;}
.protitlebox p.morelist{position: absolute;display: inline-block;padding: 0.2rem;background: rgba(255,255,255,0.8);border-radius: 1.3rem;
bottom: 0.2rem;right: 2%;}
.protitlebox p.morelist span.iconfont{color: #000;font-size: 0.5rem;line-height: 1rem;padding: 0.2px 0.35rem;background: #fff;border-radius: 1rem;float: left;
box-shadow: 0px 0px 0.3rem #FF0000;}
.product-list .product-list-body{margin-top: -6.5rem;padding: 0 1%;}
.product-list .product-list-body .product-info{border-radius: 0.3rem;background: #fff;padding:0rem;width: 47%;margin: 0 1.5%;margin-bottom: 0.8rem;}
</style>
